module.exports = __webpack_public_path__ + "static/media/lixuanzhuo.675e8cd2.png";